export const RESET_STATE = "resetModuleState";
export const FETCH_END = "setArticles";
export const FETCH_START = "setLoading";
export const SET_ERROR = "setError";

export const SET_CATEGORIES = "setCategories";
export const SET_NEW_PRODUCTS = "setNewProducts";
export const SET_HOT_PRODUCTS = "setHotProducts";

export const SET_NEWS = "setNews";
export const SET_NEWS_DETAIL = "setchNewsDetail";
export const SET_NEWS_RELATES = "setchNewsRelates";
export const SET_LATEST_NEWS = "setLatestNews";
export const SET_SUPPORTS = "setSupports";
export const SET_SERVICES = "setServices";
export const SET_NEWS_BY_CATEGORY = "setNewsByCategory";

export const SET_PAGE = "setPage";

export const SET_PRODUCTS = "setProducts";
export const SET_PRODUCTS_BY_CATEGORY = "setProductsByCategory";
export const SET_PRODUCT_DETAIL = "setProductDetail";
